<template>
  <div class="trDetail full-height linear-main3">
    <ld-header
      class="font-lg white"
      transparent
      white
    >
      车次详情
      <router-link
        class="white"
        to="/tr/OrderService"
        slot="right"
      >
        购票须知
      </router-link>
    </ld-header>

    <div class="tr-detail-info pad8">
      <travel-tips
        v-if="trSearchInfo.fromStationCityId"
        :depport-cityid="trSearchInfo.fromStationCityId"
        :arrive-cityid="trSearchInfo.toStationCityId"
        cplx="10904"
        :auto-popup="true"
      />

      <!-- 经停信息 -->
      <stop-station
        class="van-hairline--bottom"
        :detail="trSearchInfo.TrainDetail"
      />

      <van-notice-bar
        color="#fff"
        background="transparent"
        left-icon="volume"
      >
        <span class="font12">卧铺暂显示为下铺价格，最终票款以上中下铺占座结果为准。</span>
      </van-notice-bar>

      <!-- 席别列表 -->
      <div class="modify-seat round-sm bg-white">
        <van-cell-group title="请选择座席">
          <transition-group
            tag="ul"
            name="list-complete"
            class="modfity-seat-bd"
          >
            <li
              v-for="seat in trSearchInfo.TrainDetail.seatList"
              :class="[ seat.checked ? 'cur' : '', seat.canBook ? '' : 'disabled' ]"
              :key="seat.seatName"
              @click="handleCheckSeat(seat)"
            >
              <strong class="seat">
                <van-tag
                  class="vertical-middle"
                  v-show="seat.wbShow"
                  type="danger"
                  plain
                >
                  {{ $t('K303','违') }}
                </van-tag>

                {{ seat.seatName }}
              </strong>
              <div class="price">
                {{ seat.price }}
              </div>
              <div class="text">
                {{ seat.seatCountLabel }}
              </div>
              <ld-icon
                v-if="seat.checked"
                class="icon"
                type="iconxuanze"
              />
            </li>
          </transition-group>

          <!-- 选择购票渠道 -->
          <template v-if="trSearchInfo.path === '/tr/trEdit'">
            <van-cell
              v-if="trSearchInfo.PageParameter.IS12306Book"
              label="极速预订，官网直购"
              center
            >
              <ld-icon
                slot="icon"
                class="main-color"
                size="24"
                type="iconiconfont12306"
                style="margin-right: 10px;"
              />

              <template #title>
                <span class="font-bold font16">12306预订</span>
                &nbsp;&nbsp;
                <span
                  v-if="trSearchInfo.PageParameter.sellServiceCharge"
                  class="font12"
                >
                  票价 + {{ trSearchInfo.PageParameter.sellServiceCharge }}元
                </span>
              </template>

              <ld-button
                slot="right-icon"
                class="seat-btn"
                @click="valid(TravelVerificateType[12306])"
                size="sm"
                round
                orangeRed
                style="width:62px;"
              >
                {{ $t('B003','预订') }}
              </ld-button>
            </van-cell>

            <van-cell
              v-if="trSearchInfo.PageParameter.ISTgOfflineBook"
              :label="trSearchInfo.PageParameter.tgOffline_label"
              center
            >
              <img
                slot="icon"
                :src="trSearchInfo.PageParameter.tgOffline_icon"
                style="max-height: 45px; margin-right: 10px;"
              >

              <template #title>
                <span class="font-bold font16">{{ trSearchInfo.PageParameter.tgOffline_title }}</span>
                &nbsp;&nbsp;
                <span
                  v-if="trSearchInfo.PageParameter.tgOffline_sellServiceCharge"
                  class="font12"
                >
                  票价 + {{ trSearchInfo.PageParameter.tgOffline_sellServiceCharge }}元
                </span>
              </template>

              <ld-button
                slot="right-icon"
                class="seat-btn"
                @click="valid(TravelVerificateType.tgWy)"
                size="sm"
                round
                orangeRed
                style="width:62px;"
              >
                {{ $t('B003','预订') }}
              </ld-button>
            </van-cell>

            <van-cell
              v-if="trSearchInfo.PageParameter.ISofflineBook"
              :label="trSearchInfo.PageParameter.offline_label"
              center
            >
              <img
                slot="icon"
                :src="trSearchInfo.PageParameter.offline_icon"
                style="max-height: 45px; margin-right: 10px;"
              >

              <template #title>
                <span class="font-bold font16">{{ trSearchInfo.PageParameter.offline_title }}</span>
                &nbsp;&nbsp;
                <span
                  v-if="trSearchInfo.PageParameter.offline_sellServiceCharge"
                  class="font12"
                >
                  票价 + {{ trSearchInfo.PageParameter.offline_sellServiceCharge }}元
                </span>
              </template>

              <ld-button
                slot="right-icon"
                class="seat-btn"
                @click="valid(TravelVerificateType.emp)"
                size="sm"
                round
                orangeRed
                style="width:62px;"
              >
                {{ $t('B003','预订') }}
              </ld-button>
            </van-cell>
            <van-cell
              v-if="trSearchInfo.PageParameter.ISSlpOfflineBook"
              :label="trSearchInfo.PageParameter.slp_label"
              center
            >
              <img
                slot="icon"
                :src="trSearchInfo.PageParameter.slp_icon"
                style="max-height: 45px; margin-right: 10px;"
              >
              <template #title>
                <span class="font-bold font16">{{ trSearchInfo.PageParameter.slp_title }}</span>
                &nbsp;&nbsp;
                <span
                  v-if="trSearchInfo.PageParameter.slp_sellServiceCharge"
                  class="font12"
                >
                  票价 + {{ trSearchInfo.PageParameter.slp_sellServiceCharge }}元
                </span>
              </template>

              <ld-button
                slot="right-icon"
                class="seat-btn"
                @click="valid(TravelVerificateType.slzx)"
                size="sm"
                round
                orangeRed
                style="width:62px;"
              >
                {{ $t('B003','预订') }}
              </ld-button>
            </van-cell>


          </template>
          <template v-else>
            <div style="padding: 10px 30px;">
              <ld-button
                @click="valid"
                size="lg"
                main
              >
                确定
              </ld-button>
            </div>
          </template>
        </van-cell-group>
      </div>
    </div>

    <login12306
      ref="the12306"
      element=".trDetail"
      :is-popup="true"
    />

    <!-- <violate-list
      cplx="10904"
      :violate="clzcStr"
      ref="violateList"
      @selected="jump"
    /> -->
    <violate-list
      cplx="11603042"
      :violate="clzcStr"
      ref="violateList"
      @selected="jump"
    />
  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票列表页面
 * @desc 火车票列表的查询参数来源只在 store 中的 tr/trSearchInfo 中获取
 * @param {Object} trSearchInfo 查询信息对象
 * ————> @param {String} TrainDetail 火车票列表选择的车次信息
 */

import {Cell, CellGroup, NoticeBar, Tag} from 'vant'
import ldButton from 'Common/ldButton'
import { mapGetters } from 'vuex'
import StopStation from '../StopStation'
import violateList from 'Components/violateList'
import login12306 from '../trEdit/The12306'
import { TravelVerificateType } from '@/business/Domain/use-cases/train-book-interactor'
import travelTips from 'Components/travelTips'

export default {
  name: 'TrDetail',
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [NoticeBar.name]: NoticeBar,
    [Tag.name]: Tag,
    ldButton,
    StopStation,
    login12306,
    violateList,
    travelTips
  },
  data() {
    return {
      clzcStr: '',
      TravelVerificateType
    }
  },
  created () {
    // 获取本车次的违背政策
    this.clzcStr = this.trSearchInfo.TrainDetail['clzcStr']

    if (this.trSearchInfo.TrainDetail.seatList) {
      this.handleCheckSeat(
        this.trSearchInfo.TrainDetail.seatList.find(seat => seat.canBook)
      )
    }
  },
  methods: {
    handleCheckSeat (seat) {
      if (!seat || !seat.canBook) return

      this.trSearchInfo.TrainDetail.seatList.forEach(s => {
        s.checked = false
      })
      seat.checked = true
      this.trSearchInfo.SeatDetail = seat
    },
    valid(type = TravelVerificateType.emp) {
      if (this.trSearchInfo.path !== '/tr/trEdit') {
        this.jump()
        return
      }

      /*		if (new Date().getHours() < 5 || (new Date().getHours() > 22 && new Date().getMinutes() > 29)) {
				this.$dialog({
					message: '12306系统正在进行系统维护，暂不支持预订，请在05:00-23:30间下单。',
				})
				return
			}*/

      if (type == TravelVerificateType[12306]) {
        this.book12306(type)
        this.trSearchInfo.sellServiceCharge = this.trSearchInfo.PageParameter.sellServiceCharge
      } else if (type == TravelVerificateType.emp) {
        this.trSearchInfo.sellServiceCharge = this.trSearchInfo.PageParameter.offline_sellServiceCharge
        this.$dialog.alert({
          title: '火车票线下预订风险说明',
          message: this.trSearchInfo.PageParameter.offline_tips,
        }).then(() => {
          this.book(type)
        })
      } else if (type == TravelVerificateType.tgWy) {
        this.trSearchInfo.sellServiceCharge = this.trSearchInfo.PageParameter.tgOffline_sellServiceCharge
        this.book(type)
      }else if (type == TravelVerificateType.slzx) {
        this.trSearchInfo.sellServiceCharge = this.trSearchInfo.PageParameter.slp_sellServiceCharge
        this.book(type)
      }
    },
    async book12306 (type) {
      await this.$store.dispatch('tr/getLast12306Account')

      if (!this.trSearchInfo['12306Info'].trainAccount) {
        this.$refs['the12306'].open(() => {
          this.book(type)
        })
      } else {
        this.book(type)
      }
    },
    book (type = TravelVerificateType.emp) {
      this.trSearchInfo.TravelVerificateType = type
      this.trSearchInfo.SeatDetail.wb == 1 ? this.$refs['violateList'].toggle() : this.jump()
    },
    // 跳转页面
    jump(val) {
      this.$router.push({
        path: this.trSearchInfo.path,
        query: {
          ccsqdId: this.$route.query.ccsqdId,
          routeId: this.$route.query.routeId,
          s: JSON.stringify(val)
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo'
    })
  }
}
</script>

<style lang="less">
.trDetail {
  .pad8{
    padding: 8px;
  }
  .modify-seat {
    overflow: hidden;

    .van-cell {
      .van-cell__title {
        flex: 3;
      }
      .custom-title {
        width: 65px;
        margin-right: 30px;
        display: inline-block;
      }
      .van-tag {
        margin-left: 5px;
      }
    }
    .seat-btn {
      width: 62px;
      height: 30px;
      margin-left: 10px;
      font-size: 14px;
    }
  }

  .modfity-seat-bd, .modfity-seat-bd li {
    display: flex;
    padding: 10px 16px;

    li {
      display: flex;
      padding: 10px 0;
    }
  }

  .modfity-seat-bd li.cur {
    border: 1px solid;
    position: relative;
    color: #2273F7;

    .text {
      color: inherit;
    }
  }

  .modfity-seat-bd li.disabled {
    color:@color-text-gray;

    .text {
      color: inherit;
    }
  }

  .modfity-seat-bd li {
    flex: 1;
    margin-right: 8px;
    height: 78px;
    border: 1px solid #eee;
    border-radius: 6px;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .seat {
      font-size: 13px;
    }

    .price {
      font-size: 12px;
      line-height: 18px;

      &:before {
        font-size: 10px;
        content: "\00A5";
      }
    }

    .text {
      font-size: 11px;
      color: @color-text-orange;
    }

    .icon {
      position: absolute;
      content: "";
      right: -1px;
      bottom: -1px;
      color: white;
      background: #2273F7;
      padding: 2px;
      border-radius: 4px;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
